// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-bonds-information-index-js": () => import("./../../../src/templates/BondsInformation/index.js" /* webpackChunkName: "component---src-templates-bonds-information-index-js" */),
  "component---src-templates-category-js": () => import("./../../../src/templates/Category.js" /* webpackChunkName: "component---src-templates-category-js" */),
  "component---src-templates-content-index-js": () => import("./../../../src/templates/Content/index.js" /* webpackChunkName: "component---src-templates-content-index-js" */),
  "component---src-templates-home-js": () => import("./../../../src/templates/Home.js" /* webpackChunkName: "component---src-templates-home-js" */)
}

